import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import moment from 'moment';
import _ from 'lodash';
import MxVideoPlayer from 'mx-video-player';
import Timecode from 'mx-video-timecode';

import {setVideoType, setMarkInTC, setMarkOutTC, setNotice} from '../../actions';
import {Api, Config, FileDownlaodWithURL, Time} from '../../util';
import {Error, FiledownRename, Notice} from './';
import Loading from './CutLoading';

const FRAMERATE = 29.97;

const modalRoot = document.getElementById('root');
// let LIVE_TIMER;
// let VOD_TIMER;
// let CUTTING;

class Video extends Component {
	constructor(props){
		super(props);
		this.state={
			channelName: '',
			logoUrl: '',
			channelDate: '',
			channelTime: '',
			mxTime: 'mx-time',
            
			showVod: false,
			vodStartHours: '',
			editTime: '',
			markIn: '',
			markInTC: '',
			markOut: '',
			markOutTC: '',
			fullDownImgUrl: '/static/img/icon_03_01.png',
			markImgUrl: '/static/img/icon_01_01.png',
			captureImgUrl: '/static/img/icon_02_01.png',
			extendImgUrl: '/static/img/icon_03_01.png',
			showError: false,
			errorContent: {},
			loadingToggle: false,
			showFile: false,
			refileName: 'file_image',
			pos: '',
			fileToggle: '',
			sucessChk: true,
			nowUrl: props.modalInfo.url,
			showMovePlayer: false,
			memo: '',
					
			markInFlag: false,
			markOutFlag: false,

			timeValue: '',
			timePlaceholder: 'HHmmss'
		};
		// this.LIVE_TIMER = null;
		this.VOD_TIMER = null;
		this.CUTTING = null;

		this.handleErrHide = this.handleErrHide.bind(this);

		this.videoMarkIn = this.videoMarkIn.bind(this);
		this.videoMarkOut = this.videoMarkOut.bind(this);

		this.mouseOverDownLoadImg = this.mouseOverDownLoadImg.bind(this);
		this.mouseOutDownLoadImg = this.mouseOutDownLoadImg.bind(this);
		this.mouseClickDownLoadImg = this.mouseClickDownLoadImg.bind(this);

		this.mouseOverCutImg = this.mouseOverCutImg.bind(this);
		this.mouseOutCutImg = this.mouseOutCutImg.bind(this);
		this.mouseClickCutImg = this.mouseClickCutImg.bind(this);

		this.mouseOverCaptureImg = this.mouseOverCaptureImg.bind(this);
		this.mouseOutCaptureImg = this.mouseOutCaptureImg.bind(this);
		this.mouseClickCaptureImg = this.mouseClickCaptureImg.bind(this);

	


		this.handleOnLoadStart = this.handleOnLoadStart.bind(this);
		this.handleOnMarkIn = this.handleOnMarkIn.bind(this);
        
		this.handleOnMarkOut = this.handleOnMarkOut.bind(this);
	
		
		this.hideFileHandler = this.hideFileHandler.bind(this);
		this.fileKeyDown = this.fileKeyDown.bind(this);
		this.cancelFileHandler = this.cancelFileHandler.bind(this);
		this.fileNameChangeHandler = this.fileNameChangeHandler.bind(this);
		this.memoChangeHandler = this.memoChangeHandler.bind(this);

		this.handlePrevPlayer = this.handlePrevPlayer.bind(this);
		this.handleNextPlayer = this.handleNextPlayer.bind(this);

		this.handleOnTimeInputChange = this.handleOnTimeInputChange.bind(this);
		this.handleOnTimeKeyDown = this.handleOnTimeKeyDown.bind(this);
		this.handleOnTimeSearch = this.handleOnTimeSearch.bind(this);
		this.handleTimeReset = this.handleTimeReset.bind(this);
		this.handleOnFocus = this.handleOnFocus.bind(this);
		this.handleOnBlur = this.handleOnBlur.bind(this);

		this.handleOnKeyUp = this.handleOnKeyUp.bind(this);

		this.handleMarkIn = this.handleMarkIn.bind(this);
		this.handleMarkOut = this.handleMarkOut.bind(this);

		this.timeInput = React.createRef();
	}
	componentDidMount(){
		if(this.props.modalInfo){
			this.props.setVideoType('Popup');
			this.videoController(this.props.modalInfo);
			this.ADMIN = sessionStorage.getItem('auth').includes('A') || sessionStorage.getItem('auth').includes('U') || sessionStorage.getItem('id').includes('master');
		}
		this.player = this.player;
		
	}
	componentWillUnmount(){
        this.props.setVideoType('Item');
		// clearInterval(this.LIVE_TIMER);
		clearInterval(this.VOD_TIMER);
		clearInterval(this.CUTTING);
		// this.LIVE_TIMER = null;
		this.VOD_TIMER = null;
		this.CUTTING = null;
		
		// NOTE: hls 영상 요청 객체를 없앤다.
		if(this.player){
			this.player.api.destroy();
			// this.player = null;
		}
		const obj = {
			date: '',
			chName: '',
			fileName: '',
			tc: '',
		};
		this.props.setMarkInTC(obj);
		this.props.setMarkOutTC(obj);
	}

	// shouldComponentUpdate(nextProps, nextState){
	// 	if(nextState.url){
	// 		this.$player = this.player;
	// 	} 
	// 	return true;
	// }
	
	openVideo(url, live, sec){
		this.setState({url: url, live});
		// this.setState({url: '/static/test.mp4', live});
	}
	
	liveVideoController(video){
		// const logoInfo = LogoUrl(video.chName || video.chname);
		const logoInfo = _.keyBy(Config.logoUrl, 'epgId')[video.epgid];
		this.setState({
			logoUrl: logoInfo && logoInfo.imgBlack,
			channelName: video.chName,
			channelDate: Time.getToday(),
			channelTime: 'LIVE',
			mxTime: 'mx-time mx-live',
			showVod: false,
			showMovePlayer: false
		})
		this.openVideo(video.hls, true);
	}

	async videoController(video){
		const {selectedMenu} = this.props;
		// const live = video.live; // NOTE: live 플래그가 있으면 그 플래그로 처리 ==> 채널 이름 클릭시 사용.
		// const url = video.url;
		// // const hls = video.hls;
		const streamingType = this.resolveStreamingType(video);
		// const urlArr = url.split('/');
		// const dateIndex = urlArr.length - 2;
		// const timeIndex = urlArr.length - 1;
		// const urlMin = moment(urlArr[dateIndex] + urlArr[timeIndex], 'YYYY-MM-DDHHmm00').format('mm');
		if(streamingType === 'live') {
			this.liveVideoController(video);
		} else {
				const url = video.url;
				const urlArr =  url.split('/');
				const dateIndex = urlArr.length - 2;
				// const timeIndex = urlArr.length - 1;
				// const urlMin = moment(urlArr[dateIndex] + urlArr[timeIndex], 'YYYY-MM-DDHHmm00').format('mm');
				const start = moment(video.start).format('YYYYMMDDHHmmss');
				// const sec = Number(start.substr(-4,2))*60;
				// const logoInfo = LogoUrl(video.chname || video.chName);
				const logoInfo = _.keyBy(Config.logoUrl, 'title')[video.chName || video.chname];
				const vodTime = moment(video.start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss');
				const vodETime = moment(video.stop, 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss');
				const vodFileTime = moment(video.start,'YYYY-MM-DD HH:mm:ss' ).format('HH:00:00');
				const vodStartHours = vodTime.substr(0,2);
				const channelTime = selectedMenu === 'FILE' ? vodFileTime : vodTime;
				this.openVideo(url, false);
				

				await this.setState({
					logoUrl: logoInfo && logoInfo.imgBlack,
					channelName: video.chname || video.chName,
					mxTime: 'mx-time mx-vod',
					showVod: true,
					channelDate: urlArr[dateIndex], //vodTime.split(',')[0],
					channelTime, //vodTime.split(',')[1],
					vodStartTime: selectedMenu === 'FILE' ? vodFileTime : vodTime,				
					vodStartHours,
					showMovePlayer: true
				});
				// Schedule 팝업창 열었을 경우 in, out 값 자동 설정
				if(selectedMenu === 'SEARCH' || selectedMenu === 'SCHEDULE'){
					await this.setState({
						markInFlag: true,
						markInTC: `${vodTime}:00`,
						markOutFlag: true,
						markOutTC: `${vodETime}:00`,
					});

					await this.props.setMarkInTC({
						date: this.state.channelDate,
						chName: this.state.channelName,
						fileName: `${this.state.channelName}_${vodStartHours}00`,
						tc: `${vodTime}:00`
					});
	
					await this.props.setMarkOutTC({
						date: this.state.channelDate,
						chName: this.state.channelName,
						fileName: `${this.state.channelName}_${vodStartHours}00`,
						tc: `${vodETime}:00`
					});
				}

			this.VOD_TIMER = setInterval(() => {
				if(this.$player){
					const position = this.$player.api.currentTime;
					const {showVod, channelTime, vodStartHours, nowUrl} = this.state;
					if(showVod){
						// const urlInfo = nowUrl.length > 0 ? nowUrl : url;
						// const urlArr =  urlInfo.split('/');
						// const dateIndex = urlArr.length - 2;
						// const timeIndex = urlArr.length - 1;
						// const urlMin = moment(urlArr[dateIndex] + urlArr[timeIndex], 'YYYY-MM-DDHHmm00').format('mm');
						// let minutes = selectedMenu === 'FILE' ? 
						// 				parseInt(urlMin, 10) + Math.floor(position / 60)
						// 			:	Math.floor(position / 60);
						let minutes = Math.floor(position / 60);
						let seconds = Math.floor(position % 60);
						const timeStr = Timecode.fps.sec2tc(position);
						const timeRest = timeStr.split(":").slice(1).join(":");
						/* 
							***
							*** 녹화영상 30분 단위로 설정시 Config.json 파일에 추가하여 사용
							*** url 녹화파일 영상에서 시간 분 계산
							***
						*/
						// const urlArr = nowUrl.split('.');
						// const urlMin = urlArr[urlArr.length-2].slice(-2);
						// const tempTime = timeStr.split(":");
						// tempTime[1] = parseInt(tempTime[1]+urlMin, 10);
						// const timeRest = tempTime.slice(1).join(":");	// timeStr.slice(1).join(":");
						// const vodTime = vodStartHours + ':'+ timeRest;

						if(minutes < 10){
								minutes = '0' + minutes;
						}
						if(seconds < 10){
								seconds = '0' + seconds;
						}
						const vodTime = vodStartHours + ':'+ timeRest;
						this.setState({
							channelTime: vodTime
						})
					}
				}
				// this.vodTimer();
			}, 100); 
		}
	}

	resolveStreamingType(video){
    const {
      start,
      stop,
      live
    } = video;
    
    if(live){ 
				// if(false){ 
      // NOTE: live 플래그가 있으면 그 플래그로 처리 ==> 채널 이름 클릭시 사용.
      return 'live';
    } else {
      const now = moment();
      const startTime = moment(start, 'YYYY-MM-DD HH:mm:ss');
      const stopTime = moment(stop, 'YYYY-MM-DD HH:mm:ss');
      if(startTime.isBefore(now)){  // VOD 영상
        if(stopTime.isBefore(now)){  // LIVE 영상
          return 'vod';
        } else {
          return 'live';
        }
      } else {
        // 방영전
      }
    }
  }



	handleErrHide() {
		this.setState({showError: false});
	}

	// 영상 편집 In 
	async videoMarkIn(){
		await this.setState({
			markInFlag: true
		});
		await this.$player.api.setMarkIn();
	}
	// 영상 편집 Out
	async videoMarkOut(){
		await this.setState({
			markOutFlag: true
		});
		await this.$player.api.setMarkOut();
	}

	// download over
	mouseOverDownLoadImg(){
		this.setState({
			fullDownImgUrl: '/static/img/icon_03_02.png'
		})
	}
	// download out
	mouseOutDownLoadImg(){
		this.setState({
			fullDownImgUrl: '/static/img/icon_03_01.png'
		})
	}
	

	// markImg over
	mouseOverCutImg(){
		this.setState({
			markImgUrl: '/static/img/icon_01_02.png'
		})
	}
	// markImg out
	mouseOutCutImg(){
		this.setState({
			markImgUrl: '/static/img/icon_01_01.png'
		})
	}
	// markImg click
	async mouseClickCutImg(){
		const {markInTC, markIn, markOutTC, markOut} = this.state;
		if(markInTC === '' || markOutTC === ''){ // inputBox 안에 값이 없는 경우
			// alert("MarkIn과 MarkOut을 체크해주세요!!!");
			this.props.setNotice(true, 'fail', "MarkIn과 MarkOut을 체크해주세요");
		}else if(markInTC === markOutTC){ // in-out 일자 조건에 따른 예외처리 (in = out)
			// alert("MarkOut값이 MarkIn값이 같습니다");
			this.props.setNotice(true, 'fail', "MarkOut값이 MarkIn값이 같습니다");
		}else if(parseInt(Time.getDiffDay(this.props.markInInfo.date, this.props.markOutInfo.date),10) < 0){ // in-out 일자 조건에 따른 예외처리 (in < out)
			this.props.setNotice(true, 'fail', "MarkOut값이 MarkIn값보다 크게 설정하였습니다");
		}else if(Time.getDiffTime(markInTC.split(":")[0], markOutTC.split(":")[0]) > 1){
			this.props.setNotice(true, 'fail', "MarkIn과 MarkOut은 2시간을 초과할 수 없습니다");
		}else{
			const diffDate = Time.getDiffDay(this.props.markInInfo.date, this.props.markOutInfo.date);
			if(parseInt(diffDate, 10) === 0 && Timecode.fps.tc2msec(markInTC) > Timecode.fps.tc2msec(markOutTC)){ // in-out 시간 조건에 따른 예외처리 (in < out)
				this.props.setNotice(true, 'fail', "MarkOut값이 MarkIn값보다 크게 설정하였습니다");
			}else{
				const {channelName, channelTime, channelDate, vodStartTime, vodStartHours} = this.state;
				const {selectedMenu, markInInfo, markOutInfo} = this.props;
				const videoInfo = this.props.modalInfo;
		
				const markInArr = markInTC.split(':');
				const markOutArr =  markOutTC.split(':');
				let markInStr = markInArr.slice(0,-1).join('');
				let markOutStr = markOutArr.slice(0,-1).join('');
				let trimDate = '', trimMemo = '';
				if(markInInfo.date === markOutInfo.date){ // in-out 일자 비교
					trimMemo = markInArr[0] !== markOutArr[0] // in-out 시간 비교
						? 
							`${channelDate} ${markInArr[0]}~${markOutArr[0]}`
						:
							`${channelDate} ${vodStartHours}`;
					trimDate = `${channelDate} ${markInStr}~${markOutStr}`;
				}
				else{
					trimMemo = markInArr[0] !== markOutArr[0] // in-out 시간 비교
						? 
							`${markOutInfo.date} ${markInArr[0]}~${markOutArr[0]}`
						:
							`${markOutInfo.date} ${vodStartHours}`;
					trimDate = `${markInInfo.date} ${markInStr}~${markOutInfo.date} ${markOutStr}`;
				}
				const title = videoInfo.title ? videoInfo.title : '';
				const memo = `${trimMemo}시 / ${sessionStorage.getItem('name')}`;

				const logoInfo = _.keyBy(Config.logoUrl, 'title')[channelName];
				const refileName = selectedMenu === 'SCHEDULE' ? 
					// SCHEDULE일 경우
					`[${logoInfo.id}] ${trimDate} ${title}`
					:
					// FILE일 경우
					`[${logoInfo.id}] ${trimDate}`

				this.setState({
					showFile: true,
					fileToggle: 'cut',
					refileName,
					memo
				})
				
				this.player.api.pause(); // 영상 일시 정지
			}
		}
	}
	// captureImg over
	mouseOverCaptureImg(){
		this.setState({
			captureImgUrl: '/static/img/icon_02_02.png'
		})
	}
	// captureImg out
	mouseOutCaptureImg(){
		this.setState({
			captureImgUrl: '/static/img/icon_02_01.png'
		})
	}
	fileKeyDown(e){
		if(e.keyCode === 13){ // ENTER 단축키 파일 저장
			this.hideFileHandler();
		}
	}
	// 이름 변경 확인 클릭시
	hideFileHandler(ordType, fmtId, pathId){
		const {selectedMenu} = this.props;
		const videoInfo = this.props.modalInfo;
		
		const date = selectedMenu === 'SCHEDULE' ?
			moment(this.state.channelDate).format('YYYY-MM-DD') :
			// videoInfo.date;
			this.state.channelDate;
		
		// this.setState({
			// nowUrl: ''
		// });
		switch(this.state.fileToggle){
			case 'cut':
				this.fileVideoDownload(videoInfo, date, ordType, fmtId, pathId);
			break;
			case 'img':
				this.fileImgDownload(videoInfo, date);
			break;
			case 'full':
				this.fileFullDownload(videoInfo, date, ordType, fmtId, pathId);
			break;
			default :
			break;
		}

	
		
	}
	// 이름 변경 취소 클릭시
	cancelFileHandler(){
		this.setState({
			showFile: false,
		})
	}



	// 자른 동영상 다운로드
	async fileVideoDownload(videoInfo, date, ordType, fmtId, pathId) {
		const {refileName, markIn, markOut, nowUrl} = this.state;
		const {markInInfo, markOutInfo} = this.props;
		const fileNameWillDownloaded = refileName.trim();
		const chName = videoInfo.chname || videoInfo.chName
		const fileName = `${chName}_${nowUrl.substr(-8,8)}`;
		const extArr = nowUrl.split(".");
		if(this.checkValidFileName(fileNameWillDownloaded)) {
			const dur = this.$player.api.duration && !isNaN(this.$player.api.duration) ? this.$player.api.duration : markOut ;
			const cmdData = {
				chName, 
				date,
				fileName: `${markInInfo.fileName}.${extArr[extArr.length -1]}`,
				in: parseInt(markIn * 1000, 10),	// to milliseconds
				out: (markOut+1) > dur ? parseInt(dur * 1000, 10) : parseInt((markOut+1) * 1000, 10),	// to milliseconds
				saveName: fileNameWillDownloaded,	
			}
			const cmdData2 = {
				chName,
				date1: markInInfo.date,
				fileName1: `${markInInfo.fileName}.${extArr[extArr.length -1]}`,
				date2: markOutInfo.date,
				fileName2: `${markOutInfo.fileName}.${extArr[extArr.length -1]}`,
				in: parseInt(markIn * 1000, 10),
				out: (markOut+1) > dur ? parseInt(dur * 1000, 10) : parseInt((markOut+1) * 1000, 10),	// to milliseconds
				saveName: fileNameWillDownloaded,	
			}
			try{
				this.setState({
					loadingToggle: true
				})
				const trimKey  = markInInfo.fileName === markOutInfo.fileName && markInInfo.date === markOutInfo.date
					?
						(await Api.PutOrderTrim(cmdData)).key.message
					: 
						(await Api.PutOrderTrim2(cmdData2)).key.message; // 같은 영상이 아닌 경우
				this.CUTTING = setInterval(() => {
					this.getLastestJobState(trimKey, ordType, fmtId, pathId);
				}, 1000);
			} catch(e) {
				this.setState({
					loadingToggle: false,
					showFile: false,
					showError: true,
					errorContent: e
				})
			}
		} else{
			// alert('#*:|?<>"이나 공백이 아닌 문자 또는 숫자로 변경해주시기 바랍니다');
			this.props.setNotice(true, 'fail', '#*:|?<>"이나 공백이 아닌 문자 또는 숫자로 변경해주시기 바랍니다');
			this.setState({
				showFile: false
			})
		}
	}

	async getLastestJobState(trimKey, ordType, fmtId, pathId){
		try{
			let markData = (await Api.GetTrimState({trimKey})).files;
			if(markData.prog === 'D'){
				await clearInterval(this.CUTTING);
				this.CUTTING = null;
				await this.fileFileTranscoding(markData.url); // 다운로드 이력 저장
				await FileDownlaodWithURL(markData.url, markData.saveName);

				await this.setState({
					loadingToggle: false,
					showFile: false
				})
			}else{
				// console.log('loading...');
			}
		}catch(e){
			await clearInterval(this.CUTTING);
			this.CUTTING = null;
			await this.setState({
				loadingToggle: false,
				showFile: false,
				showError: true,
				errorContent: e,
			})
		}
	}

	// 자른 영상 트랜스코딩
	async fileFileTranscoding(url, fmtId = 1, pathId = 1){
		const {channelName, channelDate, vodStartHours, 
			nowUrl, refileName, memo, markInTC, markOutTC} = this.state;
		const videoInfo = this.props.modalInfo;
		const chList = JSON.parse(sessionStorage.getItem('chList'));
		const urlArr = nowUrl.split('/'); //videoInfo.url.split('/');
		const fileName = urlArr[urlArr.length-1];

		const inArr = markInTC.split(':') || [];
		const outArr = markOutTC.split(':') || [];
		
		const inLastStr = markInTC.replace(/.+:/, ";");
		const inStr = parseInt(vodStartHours, 10) + parseInt(inArr[0], 10) + ":" + inArr.slice(1).join(":") + inLastStr;

		const outLastStr = markOutTC.replace(/.+:/, ";");
		const outStr = parseInt(vodStartHours, 10) + parseInt(outArr[0], 10) + ":" + outArr.slice(1).join(":") + outLastStr;
		
		if(sessionStorage.getItem('chList')){
			try{
				this.setState({ loadingToggle: true});
				await Api.UpdateOrdDown({
					OUSERID: sessionStorage.getItem('id'),
					SCHID: chList[channelName].chId,
					SDT: channelDate,
					SFILENAME: fileName,
					SSOM: Timecode.fps.tc2msec(inStr),
					SEOM: Timecode.fps.tc2msec(outStr),
					FMTID: fmtId,
					PATHID: pathId,
					DOWNNAME: refileName.trim(),
					MEMO: memo.trim()
				});
			} catch(e){
				this.setState({
					showError: true,
					errorContent: e,
				})
			}finally {
				this.setState({
					loadingToggle: false,
					showFile: false
				})
			}
        }
	}
	

	checkValidFileName(fileName) {
		const VALID_PATTERN = /[#*:|?<>"]/;

		return !VALID_PATTERN.test(fileName) && fileName !== ''
	}



	// 이미지 다운로드
	async fileImgDownload(videoInfo, date){
		const {refileName, pos, nowUrl} = this.state;
		const fileNameWillDownloaded = refileName.trim();

		const chName = videoInfo.chname || videoInfo.chName;
		const fileName = `${chName}_${nowUrl.substr(-8,8)}`;
		if(this.checkValidFileName(fileNameWillDownloaded)) {
			const cmdData = {
				chName: chName,
				date,
				fileName,
				pos,
				saveName: fileNameWillDownloaded
			};

			try{
				await this.setState({
					loadingToggle: true,
				})
				const captureImg  = (await Api.CaptureFrame(cmdData)).files;
				if(captureImg.url.length > 0){
					await this.fileImgTranscoding(captureImg.url);
					await FileDownlaodWithURL(captureImg.url);
					
				}
				await this.setState({
					loadingToggle: false,
					showFile: false
				})
			}catch(e){
				this.setState({
					loadingToggle: false,
					showFile: false,
					showError: true,
					errorContent: e,
				})
			}
		}else{
			// alert('#*:|?<>"이나 공백이 아닌 문자 또는 숫자로 변경해주시기 바랍니다');
			this.props.setNotice(true, 'fail', '#*:|?<>"이나 공백이 아닌 문자 또는 숫자로 변경해주시기 바랍니다');
			this.setState({
				showFile: false
			})
		}
	}
	// 이미지 전송
	async fileImgTranscoding(videoInfo, pathId = 1){
		const {channelName, channelDate, refileName, memo, nowUrl} = this.state;
		const chList = JSON.parse(sessionStorage.getItem('chList'));
		const urlArr = nowUrl.split('/');
		const fileName = urlArr[urlArr.length-1];

		if(sessionStorage.getItem('chList')){
			try{
				this.setState({ loadingToggle: true});
				await Api.UpdateOrdDown({
					OUSERID: sessionStorage.getItem('id'),
					SCHID: chList[channelName].chId,
					SDT: channelDate,
					SFILENAME: fileName,
					SSOM: 0,
					SEOM: 0,
					FMTID: 0,
					PATHID: pathId,
					DOWNNAME: refileName.trim(),
					MEMO: memo.trim()
				});
			} catch(e){
				this.setState({
					showError: true,
					errorContent: e,
				})
			}finally {
				this.setState({
					loadingToggle: false,
					showFile: false
				})
			}
		}
	}

	// 전체 동영상 다운로드
 	async fileFullDownload(videoInfo, date, ordType, fmtId, pathId){
		const {refileName, nowUrl} = this.state;
		const urlArr = nowUrl.split('/');
		const timeIndex = urlArr.length - 1;
		const reFileNm = urlArr[timeIndex] = `${refileName}.mp4`;
		try{
			await this.setState({ loadingToggle: true})
			// ordType === 'S' ? await FileDownlaodWithURL(videoInfo.url, reFileNm)
			// 				: await this.fileFullTranscoding(videoInfo, fmtId, pathId);
			await this.fileFullTranscoding(videoInfo); // 다운로드 이력 저장
			await FileDownlaodWithURL(nowUrl, reFileNm);
			
		} catch(e) {
			this.setState({
				showError: true,
				errorContent: e,
			})
		} finally {
			this.setState({
				loadingToggle: false,
				showFile: false
			})
		}
	}

	// 전체 동영상 전송
	async fileFullTranscoding(videoInfo, fmtId = 1, pathId = 1){
		const {channelName, channelDate, refileName, memo} = this.state;
		const chList = JSON.parse(sessionStorage.getItem('chList'));
		const urlArr = videoInfo.url.split('/');
		const fileName = urlArr[urlArr.length-1];
		const {start, stop} = videoInfo;
		const inStr = `${Time.getTime(start)}:00`;
		
		const outStr = `${Time.getTime(stop)}:00`;
		if(sessionStorage.getItem('chList')){
			try{
				this.setState({ loadingToggle: true});
				await Api.UpdateOrdDown({
					OUSERID: sessionStorage.getItem('id'),
					SCHID: chList[channelName].chId,
					SDT: channelDate,
					SFILENAME: fileName,
					SSOM: Timecode.fps.tc2msec(inStr),
					SEOM: Timecode.fps.tc2msec(outStr),
					FMTID: fmtId,
					PATHID: pathId,
					DOWNNAME: refileName.trim(),
					MEMO: memo.trim()
				});
			} catch(e){
				this.setState({
					showError: true,
					errorContent: e,
				})
			}finally {
				this.setState({
					loadingToggle: false,
					showFile: false
				})
			}
        }
	}


	memoChangeHandler(e){
		this.setState({
			memo: e.target.value
		})
	}

	fileNameChangeHandler(e){
		this.setState({
			refileName: e.target.value
		})
	}


	// fullDownload click
	mouseClickDownLoadImg(){
		const videoInfo = this.props.modalInfo;
		const {channelName, channelDate, channelTime} = this.state;
		const {selectedMenu} = this.props;
		const title = videoInfo.title ? videoInfo.title : '';
		const logoInfo = _.keyBy(Config.logoUrl, 'title')[channelName];
		const refileName = selectedMenu === 'SCHEDULE' ? 
				// channelName + ' ' + title + ' '+ channelDate + ' ' + channelTime.substr(0,2) + '시' :
				// channelName + ' ' + channelDate + ' ' + channelTime.substr(0,2) + '시';
				`[${logoInfo.id}] ${channelDate} ${channelTime.split(':').slice(0,2).join('')} ${title}` :
				`[${logoInfo.id}] ${channelDate} ${channelTime.split(':').slice(0,2).join('')}`;
		const memo = `${channelDate} ${channelTime.split(':')[0]}시 / ${sessionStorage.getItem('name')}`;
		this.setState({
			showFile: true,
			fileToggle: 'full',
			refileName,
			memo
		})

		this.player.api.pause(); // 영상 일시 정지
	}

    // captureImg click
	mouseClickCaptureImg(){
		let restTime = "000000";
		const timeArr = Timecode.fps.sec2tc(this.$player.api.currentTime);
		restTime = timeArr.split(':').slice(1).join('');
		const videoInfo = this.props.modalInfo;
		const {channelName, channelDate, channelTime} = this.state;
		const channelArr = channelTime.split(':');
		let time = channelArr[0] + "_" + restTime;
		const {selectedMenu} = this.props;
		let pos = this.$player.api.currentTime * 1000000;
		pos -= 66732;	// 2프레임 제거
		pos = Math.floor(pos / 1000);
		const title = videoInfo.title ? videoInfo.title : '';
		const logoInfo = _.keyBy(Config.logoUrl, 'title')[channelName];
		const refileName = selectedMenu === 'SCHEDULE' ?
			`[${logoInfo.id}] ${channelDate} ${channelTime.replace(/:/gi,'').slice(0, -2)} ${title}`  : // time :
			`[${logoInfo.id}] ${channelDate} ${channelTime.replace(/:/gi,'').slice(0, -2)}`; //time;
		const memo = `${channelDate} ${channelTime.replace(/:/gi,'').slice(0, -2)} / ${sessionStorage.getItem('name')}`;
        this.setState({
			showFile: true,
			pos,
			fileToggle: 'img',
			refileName,
			memo
		})
		
		this.player.api.pause(); // 영상 일시 정지
		
	}

	// setInterval 변경
	vodTimer(){
		// if(this.$player){
		// 	const position = this.$player.api.currentTime;
		// 	const {showVod, channelTime, vodStartHours} = this.state;
		// 	if(showVod){
		// 		let minutes = Math.floor(position / 60);
		// 		let seconds = Math.floor(position % 60);
		// 		if(minutes < 10){
		// 				minutes = '0' + minutes;
		// 		}
		// 		if(seconds < 10){
		// 				seconds = '0' + seconds;
		// 		}
		// 		const vodTime = vodStartHours + ':'+ minutes + ':' + seconds;
		// 		this.setState({
		// 			channelTime: vodTime
		// 		})
		// 	}
		// }
	}

	handleOnLoadStart(){
		this.$player = this.player;
		const {channelTime, showVod, markOutTC} = this.state;
		
		// 초기화 코드
		let sec = 0.016265;
		if(channelTime){
			let second = (Number(channelTime.split(':')[2]));
			let frame = (Number(channelTime.split(':')[3]));
			second = second + 0.016265;
			sec = (Number(channelTime.split(':')[1])*60) + (second);
			if(frame) {
				frame = frame / FRAMERATE;
				sec = (Number(channelTime.split(':')[1])*60) + (second) + (frame);
			}
		}
		const timeValueArr = markOutTC.split(":");
		const stopMinute = timeValueArr[1];
		let stopSecond = timeValueArr[2];
		stopSecond = Number(stopSecond) + 0.016265;
		const stopSec = (Number(stopMinute)*60) + Number(stopSecond);
		if(showVod && sec){
			this.player.api.seek(sec);
			// this.$player.api.setMarkIn(stopSec);
			// this.$player.api.setMarkOut(stopSec);
		}


		// this.$player.log.off('INFO');
		// this.$player.log.off('HLS_INFO');
	}
	async handleOnMarkIn(sec, tc) {
		const {channelDate, channelName, vodStartHours, markInFlag} = this.state;
		const tcArr = tc.split(":");
		tcArr.splice(0, 1, vodStartHours);
		const markInTC =  tcArr.join(":");
		if(markInFlag){
			await this.props.setMarkInTC({
				date: channelDate,
				chName: channelName,
				fileName: `${channelName}_${vodStartHours}00`,
				tc: markInTC
			});
			await this.setState({
				markInTC: markInTC,
				markIn: sec//Math.floor(sec)
			});
		}
		// if(tc !== "00:00:00:00"){
		// 	this.props.setMarkInTC({
		// 		date: channelDate,
		// 		chName: channelName,
		// 		fileName: urlArr[urlArr.length-1],
		// 		tc: markInTC
		// 	});
		// }
		// this.setState({
		// 	markInTC: tc,
		// 	markIn: Math.floor(sec)
		// });
	}
	async handleOnMarkOut(sec, tc) {
		const {channelDate, channelName, vodStartHours, markOutFlag} = this.state;
		const tcArr = tc.split(":");
		tcArr.splice(0, 1, vodStartHours);
		const markOutTC =  tcArr.join(":");
		
		if(markOutFlag){
			await this.props.setMarkOutTC({
				date: channelDate,
				chName: channelName,
				fileName: `${channelName}_${vodStartHours}00`,
				tc: markOutTC
			});
			await this.setState({
				markOutTC: markOutTC,
				markOut: sec//Math.floor(sec)
			});
		}

		// if(tc !== "00:00:00:00"){
		// 	this.props.setMarkOutTC({
		// 		date: channelDate,
		// 		chName: channelName,
		// 		fileName: urlArr[urlArr.length-1],
		// 		tc: markOutTC
		// 	});
		// }
		// this.setState({
		// 	markOutTC: tc,
		// 	markOut: Math.floor(sec)
		// });
	}

	async handlePrevPlayer(){
		const {modalInfo} = this.props;
		const {nowUrl, channelTime} = this.state;
		try{
			const prevUrl = (await Api.GetPrevVod({
				chName: modalInfo.chname || modalInfo.chName,
				vodUrl: nowUrl.length <= 0 ? modalInfo.url : nowUrl
			})).files.url;
			const channelDate = prevUrl.split('/')[5];
			if(prevUrl.length > 0){
				const time = prevUrl.substr(-8,2);
				await this.setState({
					nowUrl: prevUrl,
					vodStartHours: time,
					channelTime: '',
					channelDate,
					// markInTC: '',
					// markOutTC: '',
					markInFlag: false,
					markOutFlag: false
				})
				await this.openVideo(prevUrl,false);
			}else{
				// alert("이전 영상이 존재하지 않습니다");
				this.props.setNotice(true, 'fail', "이전 영상이 존재하지 않습니다");
			}
		}catch(e){
			this.setState({
				showError: true,
				errorContent: e,
			})
			await this.player.api.pause(); // 영상 일시 정지
		}
	}
	async handleNextPlayer(){
		const {modalInfo} = this.props;
		const {nowUrl, channelTime} = this.state;
		try{
			const nextUrl = (await Api.GetNextVod({
				chName: modalInfo.chname || modalInfo.chName,
				vodUrl: nowUrl.length <= 0 ? modalInfo.url : nowUrl
			})).files.url;
			const hour = Time.getCurrentTime().split(':')[0];
			const nextUrlArr = nextUrl.split('/');
			const tempFileName = nextUrlArr[nextUrlArr.length-1].split(".");
			const time = tempFileName[0].slice(-4,-2) // 파일명
			const channelDate = nextUrlArr[nextUrlArr.length-2];
			// FIXME: time < hour
			// 1) 이걸 왜 비교하는지?
			// 2) hour와 time은 string임. (숫자가 아니라서 if문 같은 비교 불가.)
			if(nextUrl.length > 0){
				await this.setState({
					nowUrl: nextUrl,
					vodStartHours: time,
					channelTime: '',
					channelDate,
					// markInTC: '',
					// markOutTC: '',
					markInFlag: false,
					markOutFlag: false,
				})
				await this.openVideo(nextUrl,false);
			}else{
				// alert("다음 영상이 존재하지 않습니다");
				this.props.setNotice(true, 'fail', "다음 영상이 존재하지 않습니다");
			}
		}catch(e){
			this.setState({
				showError: true,
				errorContent: e,
			})
			this.player.api.pause(); // 영상 일시 정지
		}finally{
			this.setState({
				showMovePlayer: true
			})
		}
	}


	handleOnTimeInputChange(event){
		if(event.target.value.length <= 6){
			this.setState({timeValue: event.target.value});
		}else{
			// alert("6자리 이상 입력할 수 없습니다.");
			this.props.setNotice(true, 'fail', "6자리 이상 입력할 수 없습니다");
		}
	}

	// vod 입력시간 검색
	async handleOnTimeSearch(){
		const {timeValue, url, showVod} = this.state;
		const timeBoolean = moment(timeValue, 'HHmmss', true).isValid() ||  moment(timeValue, 'HH:mm:ss', true).isValid();
		if(timeBoolean){
			const timeValueFormat = timeValue.replace(/\B(?=(\d{2})+(?!\d))/g, ':');
			const timeValueArr = timeValueFormat.split(':');
			const minute = timeValueArr[1];
			let second = timeValueArr[2];
			const timeHour = timeValue.slice(0,2);
			const urlArr = url.split('.');
			const urlName = urlArr[urlArr.length-2];
			const regex = new RegExp(`(?<=\.)${urlName.slice(-4,urlName.length)}`); // 시간 후방검색 정규식
			let durMin = "00";
			/* 
				***
				*** 녹화영상 30분 단위로 설정시 Config.json 파일에 추가하여 사용 
				***
			*/
			// if(Config.durationInfo){
			// 	durMin = parseInt(minute/Config.durationInfo, 10);	// 녹화파일 duration길이와 찾는 시간위치
			// 	durMin = durMin * Config.durationInfo;
			// 	if(durMin < 10)  durMin = `0${durMin}`;
			// }
			const replaceUrl = url.replace(regex, `${timeHour}${durMin}`); // 검색시간 조건으로 url 변경
			await this.setState({ 
				nowUrl: replaceUrl,
				vodStartHours: timeHour,
				// channelTime: `${timeValueFormat}:${urlName.slice(-2,urlName.length)}}`, // {timeValueFormat}:00
				channelTime: `${timeValueFormat}:00`
				// timeValue: '',
				// timePlaceholder: timeValue
			});
			await this.openVideo(replaceUrl,false);
			second = Number(second);
			second = second + 0.016265;
			if(showVod) await this.player.api.seek((Number(minute) * 60) + Number(second));	// 검색조건으로 영상 이동
			await this.player.api.pause(); // 영상 일시 정지
		}
		else{
			// alert('입력 형식이 잘못 되었습니다. 숫자로만 입력해주세요.');
			this.props.setNotice(true, 'fail', "입력 형식이 잘못 되었습니다. 숫자로만 입력해주세요");
			this.setState({timeValue: ''});
		}
	}

	handleOnTimeKeyDown(e){
		if(e.keyCode === 13){ // ENTER 단축키 파일 저장
			this.handleOnTimeSearch();
		}
	}

	// Focus In이면 입렵된 형식 시간타입에서 입력형식으로 변경
	handleOnFocus(e){
		const {timeValue} = this.state;
		let changeType = timeValue;
		if(changeType) changeType= changeType.replaceAll(':', '');
		this.setState({timeValue: changeType});
	}

	// Focus Out이면 입련된 형식 시간타입으로 변경
	handleOnBlur(e){
		const {timeValue} = this.state;
		let changeType = timeValue;
		if(changeType) changeType= timeValue.replace(/\B(?=(\d{2})+(?!\d))/g, ':');
		this.setState({timeValue: changeType});
	}

	async handleTimeReset(){
		await this.setState({
			timeValue: ''
		});
		await this.timeInput.current.focus();
	}

	handleOnKeyUp(e){
		const {showFile} = this.state;
		if(!showFile){
			switch(e.keyCode) {
				case 38:	// up
					break;
				case 40:	// down
					break;
				// case 73:	// i (mark in)
				// 	this.videoMarkIn();
				// 	break;
				// case 79:	// o (mark out)
				// 	this.videoMarkOut();
				// 	break;
				default:
					break;
				
			}
		}
	}

	async handleMarkIn(e){
		const {url, showVod} = this.state;
		const {markInInfo} = this.props;
		if(e.keyCode === 13 && markInInfo.tc){
			const timeValueFormat = markInInfo.tc.replace(/\B(?=(\d{2})+(?!\d))/g, ':');
			const timeValueArr = timeValueFormat.split(':');
			const minute = timeValueArr[1];
			let second = timeValueArr[2];
			let frame = timeValueArr[3];
			const timeHour = markInInfo.tc.slice(0,2);
			const urlArr = url.split('.');
			const urlName = urlArr[urlArr.length-2];
			const regex = new RegExp(`(?<=\.)${urlName.slice(-4,urlName.length)}`); // 시간 후방검색 정규식
			let durMin = "00";
			/* 
				***
				*** 녹화영상 30분 단위로 설정시 Config.json 파일에 추가하여 사용 
				***
			*/
			// if(Config.durationInfo){
			// 	durMin = parseInt(minute/Config.durationInfo, 10);	// 녹화파일 duration길이와 찾는 시간위치
			// 	durMin = durMin * Config.durationInfo;
			// 	if(durMin < 10)  durMin = `0${durMin}`;
			// }
			const replaceUrl = url.replace(regex, `${timeHour}${durMin}`); // 검색시간 조건으로 url 변경
			await this.setState({ 
				nowUrl: replaceUrl,
				vodStartHours: timeHour,
				// channelTime: `${timeValueFormat}:${urlName.slice(-2,urlName.length)}}`, // {timeValueFormat}:00
				channelTime: `${timeValueFormat}:00`
				// timeValue: '',
				// timePlaceholder: timeValue
			});
			await this.openVideo(replaceUrl,false);
			second = Number(second);
			frame = Number(frame);
			second = second + 0.016265;
			frame = frame / FRAMERATE;
			if(showVod) await this.player.api.seek((Number(minute) * 60) + Number(second) + Number(frame));	// 검색조건으로 영상 이동
			await this.player.api.pause(); // 영상 일시 정지
			await this.$player.api.setMarkIn();
		}
	}

	async handleMarkOut(e){
		const {url, showVod} = this.state;
		const {markOutInfo} = this.props;
		if(e.keyCode === 13 && markOutInfo.tc){
			const timeValueFormat = markOutInfo.tc.replace(/\B(?=(\d{2})+(?!\d))/g, ':');
			const timeValueArr = timeValueFormat.split(':');
			const minute = timeValueArr[1];
			let second = timeValueArr[2];
			let frame = timeValueArr[3];
			const timeHour = markOutInfo.tc.slice(0,2);
			const urlArr = url.split('.');
			const urlName = urlArr[urlArr.length-2];
			const regex = new RegExp(`(?<=\.)${urlName.slice(-4,urlName.length)}`); // 시간 후방검색 정규식
			let durMin = "00";
			/* 
				***
				*** 녹화영상 30분 단위로 설정시 Config.json 파일에 추가하여 사용 
				***
			*/
			// if(Config.durationInfo){
			// 	durMin = parseInt(minute/Config.durationInfo, 10);	// 녹화파일 duration길이와 찾는 시간위치
			// 	durMin = durMin * Config.durationInfo;
			// 	if(durMin < 10)  durMin = `0${durMin}`;
			// }
			const replaceUrl = url.replace(regex, `${timeHour}${durMin}`); // 검색시간 조건으로 url 변경
			await this.setState({ 
				nowUrl: replaceUrl,
				vodStartHours: timeHour,
				// channelTime: `${timeValueFormat}:${urlName.slice(-2,urlName.length)}}`, // {timeValueFormat}:00
				channelTime: `${timeValueFormat}:00`
				// timeValue: '',
				// timePlaceholder: timeValue
			});
			await this.openVideo(replaceUrl,false);
			second = Number(second);
			frame = Number(frame);
			second = second + 0.016265;
			frame = frame / FRAMERATE;
			if(showVod) await this.player.api.seek((Number(minute) * 60) + Number(second) + Number(frame));	// 검색조건으로 영상 이동
			await this.player.api.pause(); // 영상 일시 정지
			await this.$player.api.setMarkOut();
		}
	}

	render() {
		const {
			channelName,
			logoUrl,
			channelDate,
			channelTime,
			mxTime,
			showVod,
			editTime,
			markIn,
			markInTC,
			markOut,
			markOutTC,
			fullDownImgUrl,
			markImgUrl,
			captureImgUrl,
			extendImgUrl,
			showError,
			errorContent,
			loadingToggle,
			showFile,
			refileName,
			showMovePlayer,
			fileToggle,
			memo,

			url,
			live,

			timeValue,
			timePlaceholder

		} = this.state;
		const {
			handleModalClose,
			selectedMenu,

			markInInfo,
			markOutInfo,

			noticeFlag
		} = this.props;
		// const prevAndNextFlag = selectedMenu === 'FILE' || selectedMenu === 'SCHEDULE';
		return ReactDOM.createPortal(
			<div id='modal-wrap'>
				<div className = 'modal video-container' onKeyUp={this.handleOnKeyUp}>
				{ showFile ? !loadingToggle? <FiledownRename
							fileToggle={fileToggle}
							memo={memo}
							hideFileHandler={this.hideFileHandler}
							fileKeyDown={this.fileKeyDown}
							cancelFileHandler={this.cancelFileHandler}
							refileName = {refileName}
							fileNameChangeHandler = {this.fileNameChangeHandler}
							memoChangeHandler={this.memoChangeHandler}
						/> : <Loading /> : null}
					<div className = 'mx-header'>
						<img className='mx-name' src={logoUrl} alt={channelName}/>
						{showVod && url &&
							<div className='time-search'>
								<div className="time-reset" onClick={this.handleTimeReset}></div>
								<input className='time-input'
									ref={this.timeInput}
									onChange={this.handleOnTimeInputChange}
									onKeyDown={this.handleOnTimeKeyDown}
									onFocus={this.handleOnFocus}
									onBlur={this.handleOnBlur}
									value={timeValue}
									maxLength='8'
									placeholder={timePlaceholder}
								/>
								<button className="go" onClick={this.handleOnTimeSearch}>Go</button>
							</div>
						}
						<div className = 'mx-day'>
							<div className = {mxTime}>{channelTime}</div>
							<div className = 'mx-date'>{channelDate} </div>
						</div>
						<span className='icon modal-close' onClick={handleModalClose}></span>
					</div>
					<div className='video-wrapper'>
					
					{showMovePlayer ? <span className='icon video-prev' onClick={this.handlePrevPlayer}></span> : null}
						<div id = 'mx-root'>
							
							{url ? (
								<MxVideoPlayer
									ref={(i) => {this.player = i;}}

									debug={false}
									live={live}
									fullscreen={true}
									autoplay={live ? true : false} // 영상플레이어 자동플레이 (live모드인 경우에만 적용)
									detection={true}
									fastforward={true}
									viewModal={true}	// 영상플레이어 sec 및 frame 단위 이동가능여부
									timecode='smtp' // 영상플레이어 frame 단위 이동 // 'sec'는 초단위 이동
									id='modal-video'
									className="chrome"
									playsinline='true'
									src={url}
			
									onLoadStart={this.handleOnLoadStart}
									onMarkIn={this.handleOnMarkIn}
                                    onMarkOut={this.handleOnMarkOut}
                                    
                                    
								/> 
							) : null}
							</div>
							
							{showMovePlayer ? <span className='icon video-next' onClick={this.handleNextPlayer}></span> : null}
							{showVod && this.ADMIN ? 
							
						<div className = 'mx-additional-ctrl'>
							<input className = 'edit-in' value={markInInfo.tc} readOnly onKeyUp={this.handleMarkIn}/>
							<button onClick = {this.videoMarkIn}>IN</button>
							<input className = 'edit-out' value={markOutInfo.tc} readOnly onKeyUp={this.handleMarkOut} />
							<button className='margin-right' onClick = {this.videoMarkOut}>OUT</button>
							<img src={markImgUrl} alt=""
									onMouseOver={this.mouseOverCutImg} 
									onMouseOut={this.mouseOutCutImg}
									onClick={this.mouseClickCutImg} />
							<span className = 'bar'></span>
							<img src={fullDownImgUrl} alt=""
									onMouseOver={this.mouseOverDownLoadImg} 
									onMouseOut={this.mouseOutDownLoadImg}
									onClick={this.mouseClickDownLoadImg} />
							<img src={captureImgUrl}  alt=""
									onMouseOver={this.mouseOverCaptureImg} 
									onMouseOut={this.mouseOutCaptureImg}
									onClick={this.mouseClickCaptureImg} />
						</div>
						: null }
						
						
					</div>
				</div>
				{showError ? 
					<Error 
						handleHide={this.handleErrHide}
						errorContent={errorContent}
						handleDetail={this.handleDetail} 
					/> 
				: null}
				{noticeFlag && <Notice /> }
			</div>
		, modalRoot);
	}
}

const mapStateToProps = (state) => {
	return {
		selectedMenu: state.selectedMenu,
		markInInfo: state.markInInfo,
		markOutInfo: state.markOutInfo,
		noticeFlag: state.noticeFlag
	}
  };


  const mapDispatcherToProps = dispatch => {
	return {
		setVideoType: (activeVideoType) => dispatch(setVideoType(activeVideoType)),
		setMarkInTC: (markInInfo) => dispatch(setMarkInTC(markInInfo)),
		setMarkOutTC: (markOutInfo) => dispatch(setMarkOutTC(markOutInfo)),
		setNotice: (flag, state, content) => dispatch(setNotice(flag, state, content))
	}
  };
  Video = connect(mapStateToProps,mapDispatcherToProps)(Video);
  
export default Video;


// WEBPACK FOOTER //
// ./src/components/modal/Video.js